import React from 'react';
import { teal } from './colors';

export interface HamburgerProps {
  /** The width of the Hamburger shape, defaults to '32px'. */
  width?: string;
  /** The color of the Hamburger shape, defaults to 'teal.base'. */
  color?: string;
}

export const Hamburger = ({ width = '32px', color = teal.base, ...rest }: HamburgerProps) => (
  <svg width={width} height={width} viewBox="0 0 32 32" {...rest}>
    <g fill="none" fillRule="evenodd">
      <rect width="32" height="32" />
      <path
        fill={color}
        d={`M7.2,23.4 C7.2,22.8477153 7.65274518,22.4 8.19667988,22.4 L23.8033201,22.4 C24.3537712,22.4 24.8,22.8438648 24.8,
            23.4 C24.8,23.9522847 24.3472548,24.4 23.8033201,24.4 L8.19667988,24.4 C7.64622878,24.4 7.2,23.9561352 7.2,23.4 Z M7.2,
            16.2 C7.2,15.6477153 7.65274518,15.2 8.19667988,15.2 L23.8033201,15.2 C24.3537712,15.2 24.8,15.6438648 24.8,16.2 C24.8,
            16.7522847 24.3472548,17.2 23.8033201,17.2 L8.19667988,17.2 C7.64622878,17.2 7.2,16.7561352 7.2,16.2 Z M7.2,9 C7.2,
            8.44771525 7.65274518,8 8.19667988,8 L23.8033201,8 C24.3537712,8 24.8,8.44386482 24.8,9 C24.8,9.55228475 24.3472548,
            10 23.8033201,10 L8.19667988,10 C7.64622878,10 7.2,9.55613518 7.2,9 Z`}
      />
    </g>
  </svg>
);
